import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { WarrantyQueryKeys } from "modules/WarrantyDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Pin } from "models";

export const usePinHistoryQuery = (pin: Pin | null, deleted: boolean) => {
  const canViewPins = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Pin);

  return useTypedQuery({
    queryKey: {
      ...WarrantyQueryKeys.pinHistory,
      params: { intervention_id: pin?.intervention_id, question_result_id: pin?.question_result_id, deleted }
    },
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.pins,
    enabled: !!(pin?.intervention_id || pin?.question_result_id) && canViewPins
  });
};
